export default __webpack_public_path__ + "static/media/audio_35_television.dc006be7.mp3";